import searchInput from '@/components/searchInput/searchInput'
import viewName from '../constant.js'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import DistributionGoodsItem from '@/components/distributionGoodsItem/distributionGoodsItem'
import {
    getDistributionList
} from '@/models/getDistributionList'
import {
    getDistributorInfo
} from '@/models/distributorMall'
export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.distributionList,
    components: {
        searchInput,
        QualityImg,
        infiniteLoadData,
        DistributionGoodsItem
    },
    data () {
        return {
            goods: [],
            carDetail: '',
            vehicle_id: '',
            distribution_code: '',
            cate_id: '',
            page: 0,
            count: 0,
            pagesize: 20,
            isload: false,
            searchValue: '',
            clientHeight: 0,
            useSearch: false,
            distribution_user_type: '',
            store_id: '',
            fromMall: '' // 判断是否从门店主页跳转过来
        }
    },
    created () {
        this.$emit('setHeader', {
            title: '商品列表',
            showHeader: true,
            showLeft: true
        })
        this.carDetail = this.$route.query.carDetail || ''
        this.vehicle_id = this.$route.query.vehicle_id || ''
        this.distribution_code = this.$route.query.distribution_code
        this.store_id = this.$route.query.store_id || ''
        this.cate_id = this.$route.query.cate_id || ''
        this.fromMall = this.$route.query.fromMall || ''
        getDistributorInfo({
            distribution_code: this.distribution_code
        }).then((res) => {
            this.hideLoading()
            this.distribution_user_type = res.distribution_user_type
            this.onSearch()
        })
    },
    methods: {
        init (scroll) {
            this.scroll = scroll
        },
        scrollToEnd () {
            if (this.goods.length < this.count) {
                this.isload = true
                this.getPageList()
            }
        },
        goCarSelect () {
            this.$router.push({
                path: '/carBrandSelect',
                query: {
                    distribution_code: this.distribution_code,
                    activeCate: this.$route.query.activeCate || '',
                    cate_id: this.cate_id,
                    fromPath:'/distributionList'
                }
            })
        },
        getSearch (value) {
            this.useSearch = true
            this.onSearch(value)
        },
        async onSearch (value) {
            this.searchValue = value
            this.page = 0
            this.goods.length = 0
            this.getPageList()
        },
        getPageList () {
            this.page++
            this.getDistributionList()
        },
        async getDistributionList () {
            try {
                if (!this.isload) {
                    this.showLoading()
                }
                const res = await getDistributionList({
                    distribution_code: this.distribution_code,
                    goods_name: this.searchValue,
                    vehicle_id: this.vehicle_id,
                    categoryId: this.cate_id,
                    store_id: this.store_id,
                    page: this.page,
                    pagesize: this.pagesize
                })
                this.hideLoading()
                const { goods, total_count } = res
                this.count = total_count
                this.goods = this.goods.concat(goods)
                if (this.goods.length === this.count) {
                    this.isload = false
                }
                this.clientHeight = Number(document.querySelector('.searchBox').clientHeight)
            } catch (e) {
                this.isload = false
            }
        },
        goClassification () {
            this.$router.push({
                path: '/goodsClassification',
                query: {
                    distribution_code: this.distribution_code,
                    activeCate: this.$route.query.activeCate || '',
                    cate_id: this.cate_id
                }
            })
        },
        onGoToPage (item) {
            if (this.fromMall) {
                this.$router.push({
                    path: '/distributionDetail',
                    query: {
                        distribution_code: this.distribution_code,
                        spec_id: item.spec_id,
                        sstore_id: item.sstore_id,
                        spu_id: item.spu_id,
                        goods_type: item.goods_type,
                    }
                })
                return
            }
            this.$router.push({
                path: '/distributionDetail',
                query: {
                    distribution_code: this.distribution_code,
                    spec_id: item.spec_id,
                    sstore_id: item.sstore_id,
                    spu_id: item.spu_id,
                    goods_type: item.goods_type,
                    distribution_user_type: this.distribution_user_type,
                    distribution_store_type: this.distribution_user_type === 2 || this.distribution_user_type === 3 ? '2' : ''
                }
            })
        }
    }
}
